export default "__VITE_ASSET__r4lzFf1R__"